import axios from 'axios'
import {
  API_HOST,
  API_FULL_PATH,
  PAGEBUILDER_ADMIN_ENABLE,
  PAGEBUILDER_SECRET_PREVIEW_SHARE,
  apiTranslatedBase,
  apiTranslatedPagebuilder,
  apiTranslatedAdmin,
} from 'utils'

const SITE = '1'
const LANG = 'it'
const baseUrl = API_HOST + '/d/'
const apiBaseUrl = API_FULL_PATH + 'react-pagebuilder/'
const adminApiBaseUrl = API_HOST + '/d/admin/api/'

const axiosInstance = apiTranslatedBase
export const apiAxiosInstance = apiTranslatedPagebuilder
export const adminApiAxiosInstance = apiTranslatedAdmin

export const api = {
  listPagebuilder,
  getPagebuilder,
  getPagebuilderJsonFile,
  saveDraftPagebuilder,
  publishPagebuilder,
  unpublishPagebuilder,
  getCustomBlocks,
  createCustomBlock,
  deleteCustomBlock,
  getGlobalCustomBlocks,
  createGlobalCustomBlock,
  updateGlobalCustomBlock,
  deleteGlobalCustomBlock,
}

function listPagebuilder(params) {
  const contentTypeId = `content_type_id=${params.contentTypeId}`
  const relatedObjectId = params.relatedObjectId
    ? `&related_object_id=${params.relatedObjectId}`
    : ''
  const lang = params?.lang ? `&lang=${params.lang}` : ''
  let url = `pagebuilder/?${contentTypeId}${relatedObjectId}${lang}`

  return apiAxiosInstance(params?.lang, true)
    .get(url)
    .then((res) => {
      return res.data
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

function getPagebuilder(params) {
  const contentTypeId = `content_type_id=${params.contentTypeId}`
  const objectId = `&object_id=${params.objectId}`
  const key = `&key=${params.key}`
  const lang = `&lang=${params.lang ? params.lang : LANG}`
  const edit_mode = params.edit_mode ? `&edit_mode=true` : ''
  let url = `pagebuilder/?${contentTypeId}${objectId}${key}${lang}${edit_mode}`

  return apiAxiosInstance(params?.lang, true)
    .get(url)
    .then((res) => {
      return res.data
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

function getPagebuilderJsonFile(params) {
  const id = params.id ? params.id : ''
  let url = `json-pagebuilder/${id}/`

  return axiosInstance(params.lang)
    .get(url)
    .then((res) => {
      return res.data
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

function saveDraftPagebuilder(pagebuilderId, json_draft, lang) {
  let body = {
    json_draft: json_draft,
  }

  return apiAxiosInstance(lang, true)
    .post(`pagebuilder/${pagebuilderId}/save_draft/`, body)
    .then((res) => {
      return res.data
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

function publishPagebuilder(pagebuilderId, lang) {
  return apiAxiosInstance(lang, true)
    .post(`pagebuilder/${pagebuilderId}/publish/`)
    .then((res) => {
      return res.data
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

function unpublishPagebuilder(pagebuilderId, lang) {
  return apiAxiosInstance(lang, true)
    .post(`pagebuilder/${pagebuilderId}/unpublish/`)
    .then((res) => {
      return res.data
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

function getCustomBlocks(params) {
  const lang = `&lang=${params.lang}`

  return apiAxiosInstance(params.lang, true)
    .get(`custom-blocks/?${lang}`)
    .then((res) => {
      return res.data
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

function createCustomBlock(params) {
  let body = {
    lang: params.lang,
    name: params.name,
    json_content: params.json_content,
  }

  return apiAxiosInstance(params.lang, true)
    .post('custom-blocks/', body)
    .then((res) => {
      return res.data
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

function deleteCustomBlock(id, lang) {
  return apiAxiosInstance(lang, true)
    .delete('custom-blocks/' + id + '/')
    .then((res) => {
      return res.data
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

function getGlobalCustomBlocks(params) {
  const lang = `&lang=${params.lang}`

  return apiAxiosInstance(params.lang, true)
    .get(`global-custom-blocks/?${lang}`)
    .then((res) => {
      return res.data
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

function createGlobalCustomBlock(params) {
  let body = {
    lang: params.lang,
    name: params.name,
    json_content: params.json_content,
  }

  return apiAxiosInstance(params.lang, true)
    .post('global-custom-blocks/', body)
    .then((res) => {
      return res.data
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

function updateGlobalCustomBlock(id, params) {
  let body = {
    lang: params.lang,
    name: params.name,
    json_content: params.json_content,
  }

  return apiAxiosInstance(params.lang, true)
    .put('react-pagebuilder/global-custom-blocks/' + id + '/', body)
    .then((res) => {
      return res.data
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

function deleteGlobalCustomBlock(id, lang) {
  return apiAxiosInstance(lang, true)
    .delete('react-pagebuilder/global-custom-blocks/' + id + '/')
    .then((res) => {
      return res.data
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}
